(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(7389);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4666);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5407);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4937);
/* harmony import */ var _components_loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8744);





(0,_builder__WEBPACK_IMPORTED_MODULE_3__/* .registerComponents */ .Q)();
var Page = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(131), __webpack_require__.e(177), __webpack_require__.e(740)]).then(__webpack_require__.bind(__webpack_require__, 3003));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3003)
            ];
        }
    }
});
var Article = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(131), __webpack_require__.e(177), __webpack_require__.e(594), __webpack_require__.e(100)]).then(__webpack_require__.bind(__webpack_require__, 9594));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9594)
            ];
        }
    }
});
var NotFound = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 797).then(__webpack_require__.bind(__webpack_require__, 797));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(797)
            ];
        }
    }
});
var PageRoot = function(props) {
    var page = props.page, model = props.model, upNextArticle = props.upNextArticle, relatedArticles = props.relatedArticles;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    if (router.isFallback) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    }
    if (model === "page") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Page, {
            page: page
        });
    }
    if (model === "article") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Article, {
            upNextArticle: upNextArticle,
            relatedArticles: relatedArticles,
            page: page
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NotFound, {});
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PageRoot);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [618,630,774,888,179], function() { return __webpack_exec__(881); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);